import { Validators } from '@angular/forms';

export const KEY_PATTERN = /^[a-z][a-z0-9_]*$/;
export const DEFAULT_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];
export const MAX_FILE_SIZE_VALIDATORS = [
  Validators.required,
  Validators.min(1),
];
